import { Text } from "@oysterhr/ui"
import { CompanyRestrictedBadge } from "../../CompanyRestrictedBadge"
import { useTranslation } from "react-i18next"

interface Props {
  restricted?: boolean
}

export const RestrictionSection = ({ restricted }: Props) => {
  const { t } = useTranslation("invoices/CompanyPaymentStatusSection", {
    keyPrefix: "customerRestrictionModal",
  })

  return (
    <div className="space-y-2">
      <Text size="small" className="font-semibold">
        {t("nonPaymentRestrictionStatus")}
      </Text>
      <CompanyRestrictedBadge restricted={restricted} />
      {restricted && (
        <Text className="text-gray-400">{t("nonPaymentRestrictionStatusContent")}</Text>
      )}
    </div>
  )
}
